/**
 * @desc 异常页面模块
 */
//异常页面
//异常404页面
const exception404 = r => require.ensure([], () => r(require('../views/exception/404.vue')), 'exception404');

export default [

  //异常404页面
  {
    name: 'exception404',
    path: '/exception404',
    component: exception404,
    meta: {title: '404页面'},
  }
]